export type OS = "mac" | "windows" | "linux" | "other";
export type Arch = "x86_64" | "aarch64";

export function detectOS(userAgent: string): OS {
  const ua = userAgent.toLowerCase();
  // Mobile UAs masquerade as their desktop cousin: Windows Phone contains
  // "windows", and iOS contains "like mac os x". Exclude them first so a phone
  // is never handed a desktop installer (there is no build it can run → "other").
  if (ua.includes("windows phone")) return "other";
  if (ua.includes("windows")) return "windows";
  // Android UAs also contain "linux" — exclude them (not a desktop target).
  if (ua.includes("android")) return "other";
  if (ua.includes("linux")) return "linux";
  if (/iphone|ipad|ipod/.test(ua)) return "other";
  if (ua.includes("mac")) return "mac";
  return "other"; // ChromeOS "CrOS" and everything else lands here
}

export function detectArch(userAgent: string): Arch {
  const ua = userAgent.toLowerCase();
  if (/aarch64|arm64|armv8/.test(ua)) return "aarch64";
  return "x86_64";
}
